import React from 'react'

import { useMediaQuery, useTheme } from '@mui/material'
import { useReactToPrint } from 'react-to-print'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

import { useDynamicManageStore } from 'store/useDynamicManageStore'

import print from 'images/print.svg'
import download from 'images/download.svg'
import { pdsAnalytics } from 'analytics/pdsAnalytics'
import Header from 'components/Headers/Header'

const printClassName = 'pds__print'
const printStyling =
    'html,body {  zoom: 85%; height: initial !important;overflow: initial !important;-webkit-print-color-adjust: exact;}@page {size: auto;margin: 20mm 2mm;}'

const PdsHeader = () => {
    const theme = useTheme()
    const onlySmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const { onBack, isStatusPending } = useDynamicManageStore((state) => state)

    const handleBack = () => {
        pdsAnalytics.track('backToDM')
        onBack()
    }

    const handlePrint = useReactToPrint({
        content: () => {
            const mainElement = document.getElementsByClassName('pds__container')[0].cloneNode(true)
            mainElement.classList.add(printClassName)
            return mainElement
        },
        onBeforeGetContent: () => {
            pdsAnalytics.track('print')
        },
        documentTitle: 'pds-summary',
        pageStyle: printStyling
    })

    const handleClone = (documentClone, elementClone) => {
        // this check is added to fix the functionality in web component
        if (documentClone.getElementsByTagName('html2canvascustomelement').length) {
            elementClone.removeAttribute('style')
            const elements = Array.from(elementClone.getElementsByTagName('*'))
            elements.forEach((element) => {
                if (element.tagName !== 'svg') {
                    element.removeAttribute('style')
                }
                if (element.classList.contains('MuiCollapse-root')) {
                    element.style.visibility = 'visible'
                    element.style.height = 'auto'
                }
                return element
            })
        }
        elementClone.classList.add(printClassName)
        elementClone.style.backgroundColor = 'white'
        elementClone.firstChild.style.padding = 0
    }

    const createPdf = (canvas) => {
        const image = { type: 'jpeg', quality: 0.98 }
        const margin = [0, 12]

        // for multi page pdf
        // const imgWidth = 480
        // const pageHeight = 576

        // for single page pdf
        const imgWidth = canvas.width > canvas.height ? canvas.height : canvas.width
        const pageHeight = canvas.height

        const innerPageWidth = imgWidth - margin[0] * 2
        let innerPageHeight = pageHeight - margin[1] * 2

        // Calculate the number of pages.
        const pxFullHeight = canvas.height
        const pxFullWidth = canvas.width
        let pxPageHeight = Math.floor(pxFullWidth * (pageHeight / imgWidth))
        pxPageHeight = onlySmallScreen ? pxPageHeight + 1500 : pxPageHeight

        const nPages = Math.ceil(pxFullHeight / pxPageHeight)

        // Create a one-page canvas to split up the full image.
        const pageCanvas = document.createElement('canvas')
        const pageCtx = pageCanvas.getContext('2d')
        pageCanvas.width = pxFullWidth
        pageCanvas.height = pxPageHeight

        // Initialize the PDF.
        const pdf = new jsPDF('p', 'px', [imgWidth, pageHeight])

        for (let page = 0; page < nPages; page++) {
            // Display the page.
            const w = pageCanvas.width
            const h = pageCanvas.height
            pageCtx.fillStyle = 'white'
            pageCtx.fillRect(0, 0, w, h)

            pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h)

            // Add the page to the PDF.
            if (page > 0) pdf.addPage()

            const imgData = pageCanvas.toDataURL('image/' + image.type, image.quality)

            pdf.addImage(imgData, image.type, margin[0], margin[1], innerPageWidth, innerPageHeight)
        }

        pdf.save('pds-summary.pdf')
    }

    const handleDownload = () => {
        pdsAnalytics.track('download')
        const mainElement = document.getElementsByClassName('pds__container')[0]

        html2canvas(mainElement, {
            useCORS: true,
            onclone: (documentClone, elementClone) => {
                handleClone(documentClone, elementClone)
            }
        }).then((canvas) => {
            createPdf(canvas)
        })
    }

    const rightSideIcons = [
        { icon: print, alt: 'print icon', handler: handlePrint },
        { icon: download, alt: 'download icon', handler: handleDownload }
    ]
    return <Header showRightSideIcons={!isStatusPending()} rightSideIcons={rightSideIcons} handleBack={handleBack} />
}

export default PdsHeader
